import { render } from "./Vault.vue?vue&type=template&id=3a4a19f1&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&lang=ts"
export * from "./Vault.vue?vue&type=script&lang=ts"

import "./Vault.vue?vue&type=style&index=0&id=3a4a19f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\friendly-fox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4a19f1"]])

export default __exports__